import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react'
import PropTypes from 'prop-types'
import Icon from '../Atoms/Icon'
import ReactDOM from 'react-dom'
import Fade from '../Atoms/Animations/Fade'
import { useKeyDownEsc } from '../../hooks/useKeyDownEsc'

const ModalTemplate = forwardRef((props, ref) => {
  const { children, className, isDefaultOpen, isLockDefaultClose } = props
  const [isOpen, setIsOpen] = useState(isDefaultOpen)
  let keyDownEsc = useKeyDownEsc()

  useImperativeHandle(ref, () => {
    return {
      openModal: () => openModal(),
      closeModal: () => closeModal(),
    }
  })

  const openModal = () => {
    setIsOpen(true)
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  const closeDefaultModal = () => {
    if (!isLockDefaultClose) closeModal()
  }

  useEffect(() => {
    if (keyDownEsc && !isLockDefaultClose) closeModal()
  }, [keyDownEsc, isLockDefaultClose])

  return ReactDOM.createPortal(
    <Fade show={isOpen}>
      <div className={`modal-template ${className}`}>
        <div className="wrapper">
          {!isLockDefaultClose && (
            <button className="close-button" onClick={closeDefaultModal}>
              <Icon className="icon" svg="cross" />
            </button>
          )}
          <section className="container">
            <div className="content">{children}</div>
          </section>
        </div>
        <div className="overlay" onClick={closeDefaultModal} />
      </div>
    </Fade>,
    document.getElementById('modal-root')
  )
})

ModalTemplate.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isDefaultOpen: PropTypes.bool,
}

ModalTemplate.defaultProps = {
  className: '',
  isDefaultOpen: false,
}

export default ModalTemplate
